import { render } from "./header.vue?vue&type=template&id=0872bdf0"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=0872bdf0&lang=less"
script.render = render

export default script